import clsx from 'clsx';
import { useMemo, useRef } from 'react';
import { Play } from 'react-feather';

import { isVideo } from '@vestico/utils';

import { getIsRTL } from '@vestico/i18n';

import style from './VideoPlayIcon.module.css';

export interface VideoPlayIconProps {
  mimeType?: string;
}
export const VideoPlayIcon = ({ mimeType }: VideoPlayIconProps) => {
  const isVideoMedia = useMemo(() => isVideo(mimeType), [mimeType]);
  const ref = useRef<HTMLDivElement>(null);
  const isRTL = useMemo(() => getIsRTL(), []);

  return isVideoMedia ? (
    <div className={clsx(style.root)} ref={ref}>
      <div className={clsx(style.imageOverlay, { [style.rtl]: isRTL })}>
        <Play />
      </div>
    </div>
  ) : null;
};
